import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { listClauses } from '@/api/documents';
import { insertHtml } from '@/lib/officeDoc';
import { Button } from '@/components/Button';

export function ClausesPane() {
  const { t } = useTranslation();
  const [jurisdiction, setJurisdiction] = useState<string>('');

  const { data, isLoading } = useQuery({
    queryKey: ['clauses', jurisdiction],
    queryFn: () => listClauses(jurisdiction || undefined),
  });

  const jurisdictions = Array.from(
    new Set((data ?? []).map((c) => c.jurisdiction).filter(Boolean) as string[]),
  );

  const onInsert = async (body: string) => {
    await insertHtml(body);
  };

  return (
    <div className="flex h-full flex-col gap-3 p-4">
      <select
        value={jurisdiction}
        onChange={(e) => setJurisdiction(e.target.value)}
        className="w-full rounded-md border border-lex-slate-200 px-2 py-1.5 text-xs"
      >
        <option value="">{t('clauses.jurisdiction')}</option>
        {jurisdictions.map((j) => (
          <option key={j} value={j}>
            {j}
          </option>
        ))}
      </select>
      <div className="flex-1 space-y-2 overflow-y-auto">
        {isLoading ? (
          <p className="text-xs text-lex-slate-500">{t('common.loading')}</p>
        ) : !data?.length ? (
          <p className="text-xs text-lex-slate-500">{t('clauses.empty')}</p>
        ) : (
          data.map((clause) => (
            <div
              key={clause.id}
              className="rounded-md border border-lex-slate-200 p-2"
            >
              <div className="flex items-start justify-between gap-2">
                <p className="text-sm font-medium">{clause.title}</p>
                <Button
                  size="sm"
                  variant="secondary"
                  onClick={() => onInsert(clause.body)}
                >
                  {t('clauses.insert')}
                </Button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
